import Cookie from 'js-cookie'
import { loginUser } from 'lib/auth'
import { useAppContext } from 'lib/hooks'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

export const LoginRedirect = (): JSX.Element => {
  const location = useLocation()
  const { enqueueSnackbar } = useSnackbar()
  const { isAuthenticated, setAuthenticated } = useAppContext()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const accessToken = params.get('j')
    if (!accessToken) return

    if (params.get('external')) {
      if (accessToken) {
        loginUser({ accessToken })
          .then(() => {
            setAuthenticated(true)
          })
          .catch((err) => {
            enqueueSnackbar(err.response?.data?.message || 'Invalid username or password.', {
              variant: 'error',
            })
          })
      }
    } else {
      Cookie.set('jwt', accessToken, {
        expires: new Date(Date.now() + 86400000 * 30),
        domain: process.env.REACT_APP_HOST_MAIN_DOMAIN,
      })
      setAuthenticated(true)
    }
  }, [location.search])

  if (isAuthenticated) {
    return <Redirect to="/" />
  }

  return <></>
}
